<div id="side-nav-container"
     class="sidenav_container" *ngIf="IsAuthenticated"
     [@onSideNavChange]="sideNavState ? 'open' : 'close'">
    <div fxLayout="column" style="height: 100%;" >
        <div>
            <mat-nav-list>
                <a mat-list-item class="hyperlink-group"
                   *ngFor="let feature of featurelist" id="{{feature?.id}}">

                    <div class="feature-item" routerLink="{{feature?.link}}" routerLinkActive="active-list-item">

                        <mat-icon id="icon-{{feature?.id}}" routerLink="{{feature?.link}}">{{feature?.icon}}</mat-icon>

                        <span class="feature-text" routerLink="{{feature?.link}}"
                              [@animateText]="linkText ? 'hide' : 'show'" >{{ feature?.name }} </span>
                    </div>
                </a>
            </mat-nav-list>
        </div>
    </div>
</div>

